import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { FiEdit2 } from "react-icons/fi";
import SlidePanel from "../../../components/SlidePanel/SlidePanel";
import * as opexService from "../../../services/opexService";

// Vendor-manageable category list (Rent, Utilities, Internet, ...): add new,
// rename, or deactivate. Deactivating hides a category from the "New Item"
// picker without touching items already using it.
function CategoryManagerPanel({ show, onHide, categories, onChanged }) {
  const [newName, setNewName] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    setSubmitting(true);
    try {
      const res = await opexService.createCategory(newName.trim());
      if (res?.success === false) {
        toast.error(res.message || "Could not create category");
      } else {
        toast.success("Category added");
        setNewName("");
        onChanged();
      }
    } catch (err) {
      toast.error(err.message || "Could not create category");
    } finally {
      setSubmitting(false);
    }
  };

  const startRename = (cat) => {
    setEditingId(cat.id);
    setEditingName(cat.name);
  };

  const saveRename = async (id) => {
    if (!editingName.trim()) return;
    try {
      const res = await opexService.updateCategory(id, editingName.trim());
      if (res?.success === false) {
        toast.error(res.message || "Could not rename category");
      } else {
        setEditingId(null);
        onChanged();
      }
    } catch (err) {
      toast.error(err.message || "Could not rename category");
    }
  };

  const toggleStatus = async (cat) => {
    const nextStatus = cat.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    try {
      await opexService.setCategoryStatus(cat.id, nextStatus);
      onChanged();
    } catch (err) {
      toast.error(err.message || "Could not update category");
    }
  };

  return (
    <SlidePanel show={show} onHide={onHide} title="Manage Categories" width={420}>
      <Form onSubmit={handleAdd} className="d-flex gap-2 mb-4">
        <Form.Control placeholder="New category name" value={newName} onChange={(e) => setNewName(e.target.value)} />
        <Button type="submit" disabled={submitting} style={{ background: "var(--button-color)", border: "none", color: "#fff" }}>
          Add
        </Button>
      </Form>

      <div className="d-flex flex-column" style={{ gap: "8px" }}>
        {categories.map((cat) => (
          <div
            key={cat.id}
            className="d-flex align-items-center justify-content-between"
            style={{ padding: "8px 12px", border: "1px solid #E5E7EB", borderRadius: "8px" }}
          >
            {editingId === cat.id ? (
              <Form.Control
                size="sm"
                autoFocus
                value={editingName}
                onChange={(e) => setEditingName(e.target.value)}
                onBlur={() => saveRename(cat.id)}
                onKeyDown={(e) => e.key === "Enter" && saveRename(cat.id)}
                style={{ maxWidth: 220 }}
              />
            ) : (
              <span style={{ opacity: cat.status === "ACTIVE" ? 1 : 0.5 }}>{cat.name}</span>
            )}
            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                onClick={() => startRename(cat)}
                style={{ border: "none", background: "none", color: "#6B7280", cursor: "pointer" }}
                aria-label="Rename"
              >
                <FiEdit2 size={14} />
              </button>
              <Form.Check
                type="switch"
                checked={cat.status === "ACTIVE"}
                onChange={() => toggleStatus(cat)}
                title={cat.status === "ACTIVE" ? "Deactivate" : "Activate"}
              />
            </div>
          </div>
        ))}
      </div>
    </SlidePanel>
  );
}

export default CategoryManagerPanel;
